import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import CustomerHead from '../../components/customer/CustomerHead';

export default function CustomerService(){
  return (
      <ServiceWrap>
        <CustomerHead title="Pest Services" back={true}/>
        <main className="content">
          <div className="service-link">
            <NavLink to='/customer/service/commercial'>
              <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/client/c_service01.webp" alt="commercial" />
            </NavLink>
          </div>

          <div className="service-link">
            <NavLink to='/customer/service/residential'>
              <img src="https://ust-india.s3.ap-northeast-2.amazonaws.com/client/c_service02.webp" alt="residential" />
            </NavLink>
          </div>
        </main>
      </ServiceWrap>
  )
}

const ServiceWrap = styled.div`
  position: relative;
  background: #F9FAFB;
  
  .content {
    position:relative;
    padding: 20px 20px 80px 20px;
    
    .service-link {
      position:relative;
      width:100%;
      
      img {
        width:100%;
      }
    }
    
    .service-link + .service-link {
      margin-top: 30px;
    }
  }
`